import React from 'react';

const ToggleRight = () => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M.5996 1.7143L4.3496 6l-3.75 4.2857.75 1.7143 5.25-6-5.25-6-.75 1.7143z" fill="#fff" />
  </svg>
);

export default ToggleRight;
